export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4079a32e64e1a422f31800a2e76b98c2b9c9233dca&name=revalidateCommunity!'